import React from "react";
import styles from "./DetailsPage.module.css";
import { Breadcrumb } from "antd";
import { HeaderClass, Footer } from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { apiGet } from "../../utils/axiosFn";
import { Spin, Empty } from "antd";

const withDetailsPage = (Children: any) => {
  return (props: any) => {
    const loaction = useLocation();
    const navigate = useNavigate();
    return <Children {...props} loaction={loaction} navigate={navigate} />;
  };
};

export class DetailsPageComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      obj: {},
      isLoading: true,
      error: null,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const type = this.props.loaction.state;
    const { navigate } = this.props;
    let id = -1;
    if (type === null) {
      id =
        this.props.loaction.pathname.split("/")[
          this.props.loaction.pathname.split("/").length - 1
        ];
    } else {
      id = this.props.loaction.state.id;
    }

    try {
      let data = {
        articleId: id,
      };
      const res = await apiGet(
        "/api/article/detail",
        { params: data },
        null,
        null
      );

      // if (res === null) return window.history.go(-1)
      this.setState({ obj: res, isLoading: false });
    } catch (error) {
      this.setState({ error: error });
      this.setState({ isLoading: false });
    }
  }

  componentWillReceiveProps(nextProps: any) {
    window.location.reload();
  }
  render() {
    const type = this.props.loaction.state;
    const { navigate } = this.props;

    let text = "";
    if (type === null) {
      text = "";
    } else {
      text = this.props.loaction.state.text;
    }

    // if (this.state.obj == {}) {
    //     window.history.go(-1)
    //     return null

    // }

    const { obj, isLoading, error } = this.state;

    if (isLoading)
      return (
        <Spin
          tip="Loading..."
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "500px",
          }}
        ></Spin>
      );
    if (error !== null)
      return (
        <h1 style={{ textAlign: "center", marginTop: "30vh" }}>
          {" "}
          {navigate("/")} <Empty />{" "}
        </h1>
      );
    if (!isLoading && error === null)
      return (
        <>
          <HeaderClass />
          <div className={styles["w"]}>
            <Breadcrumb
              separator=""
              className={styles["Breadcrumb"]}
              style={{ marginTop: "20px", fontSize: "15px", color: "#000" }}
            >
              <Breadcrumb.Item>当前位置</Breadcrumb.Item>
              <Breadcrumb.Separator>
                {" "}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </Breadcrumb.Separator>
              <Breadcrumb.Item href="" onClick={() => navigate("/")}>
                首页
              </Breadcrumb.Item>
              <Breadcrumb.Separator> &gt; </Breadcrumb.Separator>

              <Breadcrumb.Item
                href=""
                onClick={() =>
                  navigate(`/item/${text}`, { state: { id: text } })
                }
              >
                {text}
              </Breadcrumb.Item>
            </Breadcrumb>
            <div
              style={{
                width: "1080px",
                height: "2px",
                background: "#285D87",
                marginTop: "10px",
              }}
            ></div>
            <div className={styles["text"]}>
              <div className={styles["title"]} style={{ textAlign: "center" }}>
                {obj.title}
              </div>
              <div
                className={styles["title content"]}
                style={{ textAlign: "center" }}
              >
                来源: {obj.author} &nbsp; &nbsp; &nbsp; {obj.createTime}
              </div>
              <div className={styles["shortContent"]}>{obj.shortContent}</div>
              <div
                className={styles["edit_img"]}
                dangerouslySetInnerHTML={{ __html: obj.content }}
              ></div>
            </div>
            {/* <div className={styles["page"]}>
              <div
                className={styles["item"]}
                onClick={() =>
                  navigate(`/details/${obj.pre.id}`, {
                    state: { id: obj.pre.id, text },
                  })
                }
              >
                <div> &lt;上一篇 </div>
                <div>{obj.pre !== null ? obj.pre.title : "无"}</div>
              </div>
              <div
                className={styles["item"]}
                onClick={() =>
                  navigate(`/details/${obj.next.id}`, {
                    state: { id: obj.next.id, text },
                  })
                }
              >
                <div> &gt;下一篇 </div>
                <div>{obj.next !== null ? obj.next.title : "无 "}</div>
              </div>
            </div> */}
          </div>
          <Footer />
        </>
      );
  }
}

export const DetailsPage = withDetailsPage(DetailsPageComponent);
